import { PatientMedicalHistoryFormValues } from '../../models';

export class FetchPatientMedicalHistory {
  static readonly type = '[Patient Medical History] Fetch Patient Medical History';
}

export class FetchHealthConditions {
  static readonly type = '[Patient Medical History] Fetch Health Conditions';
}

export class UpdatePatientMedicalHistory {
  static readonly type = '[Patient Medical History] Update Patient Medical History';
  constructor(public formValues: PatientMedicalHistoryFormValues) {}
}
